//@flow
import ImageSource from "../../source/image_source";
import browser from "../../util/browser";
import SingleGet from "./single-ajax";
import { queryString, debounce } from "./util";
import { Event, ErrorEvent } from "../../util/evented";
import { extend } from "../../util/util";
class AgsDynamicSource extends ImageSource {
    constructor(
        id: string,
        options: ImageSourceSpecification | VideoSourceSpecification | CanvasSourceSpecification,
        dispatcher: Dispatcher,
        eventedParent: Evented,
    ) {
        super(id, options, dispatcher, eventedParent);
        this.type = "ags-dynamic-source";
        this.url = options.url;
        this.updateUrl = debounce(this.updateUrl.bind(this), 500);
    }

    load(updateFlag) {
        this.fire(new Event("dataloading", { dataType: "source" }));

        const url = this.getUrl();
        const newCoordinates = this.getCoordinates();

        this.singeGet.get(url, (err, image) => {
            if (err) {
                this.fire(new ErrorEvent(err));
            } else if (image) {
                this.image = browser.getImageData(image);
                this.coordinates = newCoordinates;
                if (this.texture) {
                    this.texture.update(this.image);
                }
                this._finishLoading(updateFlag);
            }
        });
    }
    _finishLoading(updateFlag) {
        if (this.map) {
            this.setCoordinates(this.coordinates);
            this.fire(new Event("data", { dataType: "source", sourceDataType: "metadata" }));
        }
        /**
         * ugly hack to fix updated image not show
         */
        if (updateFlag) {
            setTimeout(() => {
                this.map._update();
            }, 100);
        }
    }
    serialize() {
        return {
            type: "ags-dynamic-source",
            url: this.url,
            token: this.options.token,
            srid: this.options.srid,
        };
    }

    /**
     * @description è·åå½ååºåçå¨æè¯·æ±url
     */
    getUrl(): string {
        const params = this.getParams();
        const url: string = `${this.url}?${queryString(params)}`;
        return url;
    }
    /**
     * @description
     */
    getParams() {
        const params = this.options.params;
        const defaultParams = AgsDynamicSource.defaultParams;
        const bbox: number[] = this.getBbox();
        const imageSize: number[] = this.getImageSize();
        const result = extend(
            extend(defaultParams, {
                bbox,
                imageSize,
            }),
            params,
        );
        return result;
    }
    /**
     * @description è·åå½åcanvaså°ºå¯¸
     * @returns [width,height]
     */
    getImageSize(): number[] {
        const width = this.map.getCanvas().width;
        const height = this.map.getCanvas().height;
        return [width, height];
    }

    /**
     * @description è·åå°å¾å½åç bbox
     */
    getBbox(): number[] {
        const bounds: mapboxgl.LngLatBounds = this.map.getBounds();
        const ne: mapboxgl.LngLatLike = bounds.getNorthEast();
        const sw: mapboxgl.LngLatLike = bounds.getSouthWest();
        const bbox: number[] = [ne.lng, ne.lat, sw.lng, sw.lat];
        return bbox;
    }

    /**
     * @description è·åå°å¾å½åçCoordinates
     */
    getCoordinates(): number[][] {
        const bounds: mapboxgl.LngLatBounds = this.map.getBounds();

        // const ne: mapboxgl.LngLatLike = this.map.getBounds().getNorthEast();
        // const sw: mapboxgl.LngLatLike = this.map.getBounds().getSouthWest();
        const coord: number[][] = [
            [bounds.getNorthWest().lng, bounds.getNorthWest().lat],
            [bounds.getNorthEast().lng, bounds.getNorthEast().lat],
            [bounds.getSouthEast().lng, bounds.getSouthEast().lat],
            [bounds.getSouthWest().lng, bounds.getSouthWest().lat],
        ];
        return coord;
    }
    onAdd(map) {
        this.map = map;
        this.singeGet = new SingleGet(map);
        this.load();
        this.bindEvent();
    }
    onRemove() {
        this.unbindEvent();
        this.singeGet.destory();
    }
    setParams(params) {
        this.options.params = extend(this.options.params, params);
        this.updateUrl();
    }
    updateUrl() {
        this.load(true);
    }
    bindEvent() {
        this.map.on("moveend", this.updateUrl);
    }
    unbindEvent() {
        this.map.off("moveend", this.updateUrl);
    }
}
AgsDynamicSource.defaultParams = {
    bboxSR: "4490",
    imageSR: "4490",
    dpi: 96,
    transparent: true,
    format: "png8",
    f: "image",
};
export default AgsDynamicSource;
